import Vue from 'vue';
import App from './App.vue';

import Layout from './components/common/Layout.vue';
import router from '@/router/index';
import i18nInstance from '@/i18n/initI18n';
import '@/utils/flexible'; // rem 计算
import '@/assets/css/reset.css';
import '@/assets/css/public.scss';
import 'swiper/css/swiper.css';
import 'animate.css';

Vue.component('Layout',Layout);
Vue.config.productionTip = false;
new Vue({
	router,
	i18n:i18nInstance,
	render: h => h(App),
}).$mount('#app');
